import React from 'react';
import { Redirect } from 'react-router-dom';

const LoginReceiver = () => {
  return <Redirect to="/" />;
};

export default LoginReceiver;
